import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_component = _resolveComponent("card-component")!

  return (_openBlock(), _createBlock(_component_card_component, {
    img: require('./assets/imageEquilibrium.jpg'),
    altImg: "Image of an Equilibrium",
    title: "Equilibrium #3429",
    description: "Our\n    Equilibrium collection promotes balance and calm",
    value: 0.041,
    currency: "ETH",
    time: 3,
    creator: "Jules Wyvern",
    creatorLink: "https://dellaquila.dev",
    avatar: require('./assets/imageAvatar.png'),
    avatarAlt: "avatar of the creator",
    viewImg: require('./assets/iconView.svg'),
    viewAlt: "View icon"
  }, null, 8, ["img", "value", "avatar", "viewImg"]))
}